import { render } from "./PenilaianKpiDetail.vue?vue&type=template&id=6f47b03f"
import script from "./PenilaianKpiDetail.vue?vue&type=script&lang=js"
export * from "./PenilaianKpiDetail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__